import React from 'react'
import { Parser } from '../../common'

const UnderTheme = ({ block }) => {
    return (
        <div className="block-under-theme">
            {block?.childrens && <Parser content_block={block.childrens} />}
        </div>
    )
}

export default UnderTheme
